import React, { createContext, useContext, useEffect, useState } from "react";
import { translations } from "@/lib/translations";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    if (typeof window === "undefined") return "pt";
    const saved = localStorage.getItem("faustitur_lang");
    if (saved && translations[saved]) return saved;
    const nav = (navigator.language || "pt").slice(0, 2);
    return translations[nav] ? nav : "pt";
  });

  useEffect(() => {
    if (typeof window !== "undefined") {
      localStorage.setItem("faustitur_lang", lang);
      document.documentElement.lang = lang;
    }
  }, [lang]);

  const t = translations[lang] || translations.pt;

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLang() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
}
